module.exports = __webpack_public_path__ + "img/编组 7.1f78946e.png";